import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import styles from './messagesIndexNavStyles.scss';

const ROUTES = [
  { label: 'Inbox', href: '' },
  { label: 'Unread', href: 'unread' },
  { label: 'Read', href: 'read' },
  { label: 'Archive', href: 'archive' }
];

const MessagesIndexNav: React.FC = () => {
  const { pathname } = useLocation();

  const isCreatingMessage = pathname.includes('/new');

  return (
    <div className={styles.messagesNavigation}>
      <div className={styles.navHeading}>
        <h3>Messages</h3>
        <Link to={isCreatingMessage ? '/' : '/new'}>
          <Button
            size={BUTTON_SIZES.SMALL}
            text={isCreatingMessage ? 'Back to Inbox' : 'New Message'}
            type={isCreatingMessage ? BUTTON_TYPES.SECONDARY : BUTTON_TYPES.MAJOR}
          />
        </Link>
      </div>
      <div className={styles.navMenu}>
        {ROUTES.map(({ label, href }) => (
          <NavLink
            key={href}
            to={href}
            className={({ isActive }) => (isActive ? styles.active : null)}
          >
            {label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default MessagesIndexNav;
